import React, { useState, useEffect } from "react";
import { notification } from "antd";
import { onMessageListener } from "./firebase";

interface NotificationPayload {
  title: string;
  body: string;
}

interface FirebaseMessagePayload {
  data?: {
    title?: string;
    body?: string;
  };
}

const Notification: React.FC = () => {
  const [notificationPayload, setNotificationPayload] =
    useState<NotificationPayload | null>(null);

  const openNotification = (title: string, body: string) => {
    notification.open({
      message: title,
      description: body,
      duration: 3,
    });
  };

  useEffect(() => {
    if (notificationPayload?.title) {
      openNotification(notificationPayload.title, notificationPayload.body);
    }
  }, [notificationPayload]);

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        const typedPayload = payload as FirebaseMessagePayload;
        setNotificationPayload({
          title: typedPayload.data?.title || "No Title",
          body: typedPayload.data?.body || "No Body",
        });
      })
      .catch((err) => console.error("Failed to receive message: ", err));
  }, []);

  return null;
};

export default Notification;
